module.exports = __webpack_public_path__ + "img/icon_review0.95d35621.png";